import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "loading-overlay" }
const _hoisted_2 = { class: "loading-dialog" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-dialog-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loading_modal" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-heart heartbeat" }),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "title" }, "LOADING")
  ])
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "loading-dialog"
}
const _hoisted_6 = { class: "loading-dialog-body" }
const _hoisted_7 = { class: "spinLoading-modal" }
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512 /* NEED_PATCH */), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512 /* NEED_PATCH */), [
      [_vShow, _ctx.loading || _ctx.isLoading]
    ]),
    (_ctx.spinLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("strong", null, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.loaderText), 1 /* TEXT */)
                ])
              ]),
              _hoisted_9,
              _hoisted_10,
              _hoisted_11
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}